type IArquivos = {
    arquivo: any;
    nome: string;
};

type ISubPasta = {
    titleSubPasta: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};

type IMaterial = {
    isPaste?: boolean;
    titlePaste?: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};
type TItem = {
    title: string;
    materiais: IMaterial[];
};

export const ListMateriasFVMatematica: TItem[] = [
    {
        title: 'Avaliação Formativa',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Matemática',
                arquivos: [
                    {
                        nome: 'FV_MAT_OrientacoesParaCorrecao_Aplicacao',
                        arquivo: 'FV_Materiais_2026/MATEMÁTICA/AVALIAÇÃO FORMATIVA/MATEMÁTICA/FV_MAT_OrientacoesParaCorrecao_Aplicacao.pdf',
                    },
                    {
                        nome: 'FV-MAT-Avaliação 1',
                        arquivo: 'FV_Materiais_2026/MATEMÁTICA/AVALIAÇÃO FORMATIVA/MATEMÁTICA/FV-MAT-Avaliação 1.pdf',
                    },
                    {
                        nome: 'FV-MAT-Avaliação 2',
                        arquivo: 'FV_Materiais_2026/MATEMÁTICA/AVALIAÇÃO FORMATIVA/MATEMÁTICA/FV-MAT-Avaliação 2.pdf',
                    },
                    {
                        nome: 'FV-MAT-Avaliação 3',
                        arquivo: 'FV_Materiais_2026/MATEMÁTICA/AVALIAÇÃO FORMATIVA/MATEMÁTICA/FV-MAT-Avaliação 3.pdf',
                    },
                    {
                        nome: 'Quadro_habilidades_U1a3_FV_MAT',
                        arquivo: 'FV_Materiais_2026/MATEMÁTICA/AVALIAÇÃO FORMATIVA/MATEMÁTICA/Quadro_habilidades_U1a3_FV_MAT.pdf',
                    },
                    {
                        nome: 'Quadros_habilidades_U4a6_FV_MAT',
                        arquivo: 'FV_Materiais_2026/MATEMÁTICA/AVALIAÇÃO FORMATIVA/MATEMÁTICA/Quadros_habilidades_U4a6_FV_MAT.pdf',
                    },
                    {
                        nome: 'Quadros_habilidades_U7e8_FV_MAT',
                        arquivo: 'FV_Materiais_2026/MATEMÁTICA/AVALIAÇÃO FORMATIVA/MATEMÁTICA/Quadros_habilidades_U7e8_FV_MAT.pdf',
                    },
                ],
            },
        ],
    },

    {
        title: 'Materiais Didáticos',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Matemática',
                subPastas: [
                    {
                        titleSubPasta: 'Livro Aluno',
                        arquivos: [
                            {
                                nome: 'FV_Mat_Aluno',
                                arquivo: 'FV_Materiais_2026/MATEMÁTICA/MATERIAIS DIDÁTICOS/MATEMÁTICA/LIVRO ALUNO/FV_Mat_Aluno.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Livro Professor',
                        arquivos: [
                            {
                                nome: 'FV_Mat_Professor',
                                arquivo: 'FV_Materiais_2026/MATEMÁTICA/MATERIAIS DIDÁTICOS/MATEMÁTICA/LIVRO PROFESSOR/FV_Mat_Professor.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Mapa Habilidades BNCC',
                        arquivos: [
                            {
                                nome: 'FV_MAT_MAPA_BNCC',
                                arquivo:
                                    'FV_Materiais_2026/MATEMÁTICA/MATERIAIS DIDÁTICOS/MATEMÁTICA/MAPA HABILIDADES BNCC/FV_MAT_MAPA_BNCC.pdf',
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        title: 'Teste Diagnóstico',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Matemática',
                arquivos: [
                    {
                        nome: 'FV_MAT_TESTE_DIAGNOSTICO_ALUNO_digital',
                        arquivo: 'FV_Materiais_2026/MATEMÁTICA/TESTE DIAGNÓSTICO/MATEMÁTICA/FV_MAT_TESTE_DIAGNOSTICO_ALUNO_digital.pdf',
                    },
                    {
                        nome: 'FV_MAT_TESTE_DIAGNOSTICO_ORIENTACOES',
                        arquivo: 'FV_Materiais_2026/MATEMÁTICA/TESTE DIAGNÓSTICO/MATEMÁTICA/FV_MAT_TESTE_DIAGNOSTICO_ORIENTACOES.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Visão Geral Sistemática e Diretrizes',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'FV_CADERNO_DIRETRIZES',
                        arquivo: 'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/FV_CADERNO_DIRETRIZES.pdf',
                    },
                    {
                        nome: 'Visão geral_Fórmula da Vitória',
                        arquivo: 'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Visão geral_Fórmula da Vitória.pdf',
                    },
                    {
                        nome: 'Sistematica FORMULA DA VITÓRIA_MATEMATICA',
                        arquivo:
                            'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Sistematica FORMULA DA VITÓRIA_MATEMATICA.pdf',
                    },
                ],
                subPastas: [
                    {
                        titleSubPasta: 'Cartazes',
                        arquivos: [
                            {
                                nome: 'Cartaz de Acompanhamento Mensal IA_MAT',
                                arquivo:
                                    'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Cartazes/Cartaz de Acompanhamento Mensal IA_MAT.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Tabelas',
                        arquivos: [
                            {
                                nome: 'FV_Acompanhamento_Bimestral_I',
                                arquivo:
                                    'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_Acompanhamento_Bimestral_I.pdf',
                            },
                            {
                                nome: 'FV_Acompanhamento_Bimestral_II',
                                arquivo:
                                    'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_Acompanhamento_Bimestral_II.pdf',
                            },
                            {
                                nome: 'FV_MAT_Acompanhamento_Mensal_I_B_Nivel_1',
                                arquivo:
                                    'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_MAT_Acompanhamento_Mensal_I_B_Nivel_1.pdf',
                            },
                            {
                                nome: 'FV_MAT_Acompanhamento_Mensal_I_B_Nivel_2',
                                arquivo:
                                    'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_MAT_Acompanhamento_Mensal_I_B_Nivel_2.pdf',
                            },
                            {
                                nome: 'FV_MAT_Acompanhamento_Mensal_II_Nivel_1',
                                arquivo:
                                    'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_MAT_Acompanhamento_Mensal_II_Nivel_1.pdf',
                            },
                            {
                                nome: 'FV_MAT_Acompanhamento_Mensal_II_Nivel_2',
                                arquivo:
                                    'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_MAT_Acompanhamento_Mensal_II_Nivel_2.pdf',
                            },
                            {
                                nome: 'FV_MAT_Perfil_Turma_I',
                                arquivo: 'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_MAT_Perfil_Turma_I.pdf',
                            },
                            {
                                nome: 'FV_MAT_Perfil_Turma_II',
                                arquivo: 'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_MAT_Perfil_Turma_II.pdf',
                            },
                            {
                                nome: 'FV_Resultado_Final_I',
                                arquivo: 'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_Resultado_Final_I.pdf',
                            },
                            {
                                nome: 'FV_Resultado_Final_II',
                                arquivo: 'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Tabelas/FV_Resultado_Final_II.pdf',
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
